
export class TimeZoneData {
  supplementalData: TimeZoneSupplementalData;

  constructor(rawData: any) {
    this.supplementalData = new TimeZoneSupplementalData(rawData.supplementalData);
  }
}

export class TimeZoneSupplementalData {
  version: string;
  windowsZones: TimeZonesWindows;

  constructor(rawData: any) {
    this.version = rawData.version._number;
    this.windowsZones = new TimeZonesWindows(rawData.windowsZones);
  }
}

export class TimeZonesWindows {
  mapTimezones: TimeZonesMapContainer;

  constructor(rawData: any) {
    this.mapTimezones = new TimeZonesMapContainer(rawData.mapTimezones);
  }
}

export class TimeZonesMapContainer {
  mapZone: TimeZoneMap[] = [];
  otherVersion: string;
  typeVersion: string;

  constructor(rawData: TimeZonesMapContainerRaw) {
    rawData.mapZone.forEach((raw: TimeZoneMapRaw) => {
      this.mapZone.push(new TimeZoneMap(raw));
    });
    this.otherVersion = rawData._otherVersion;
    this.typeVersion = rawData._typeVersion;
  }
}

export class TimeZoneMap {
  windowsTz: string;
  territory: string;
  ianaArray: string[];

  constructor(rawData: TimeZoneMapRaw) {
    this.windowsTz = rawData._other;
    this.territory = rawData._territory;
    this.ianaArray = rawData._type.split(' ');
  }
}

// raw data, needs to be converted becaue an array is represented by a space seperated string at the lowest level
export class TimeZonesMapContainerRaw {
  mapZone: TimeZoneMapRaw[];
  _otherVersion: string;
  _typeVersion: string;
}

export class TimeZoneMapRaw {
  _other: string; // windows time, EX: "Eastern Standard Time"
  _territory: string;
  _type: string; // IANA time, EX: "America/New_York America/Detroit"
}
